import React from "react"
import AccountLayout from "@/components/AccountLayout"
import Message from "@/components/Message"
import Register from "../components/Register"
import { Text, SimpleGrid } from "@chakra-ui/react"
import { Image } from "@chakra-ui/react"
import EmmeLogo from "../images/emmeLogo.png"
import CallBoxLogo from "../images/callboxLogo.png"
import LaconicLogo from "../images/laconicLogo.png"
import GdahaLogo from "../images/gdahaLogo.png"

export default function RegisterView() {
  const gradientBox = <Register />

  const message = (
    <Message>
      <Text variant="register" p="8">
        “Partnering with Blind Insight allowed us to accelerate our roadmap by a
        full year, moving us into new product areas and unlocking revenue faster
        than we could on our own.”
      </Text>

      <Text variant="sm" p="8" pt="4">
        &mdash; Erynn Petersen, CEO, Emme
        <br />
        Former CTO Kessel Run, US Dept. of Defense
      </Text>
      <SimpleGrid
        columns={[1, null, 4]}
        gap="40px"
        p="8"
        alignItems="center"
        mt="4"
      >
        <Image width="40" src={EmmeLogo} alt="Emme Logo" />
        <Image width="40" src={CallBoxLogo} alt="Call Box Logo" />
        <Image width="40" src={LaconicLogo} alt="Laconic Logo" />
        <Image width="40" src={GdahaLogo} alt="Gdaha Logo" />
      </SimpleGrid>
    </Message>
  )
  return <AccountLayout gradientBox={gradientBox} message={message} />
}
